import { render, staticRenderFns } from "./HostingCallToAction.vue?vue&type=template&id=faa7154a&"
import script from "./HostingCallToAction.vue?vue&type=script&lang=js&"
export * from "./HostingCallToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports